validEffects